import { formatLedgerMoney } from '@/lib/api/accounts'
import {
  formatZReportDateTime,
  normalizePaymentMix,
} from '@/lib/accounts/zReport'

/**
 * @param {object} props
 * @param {object | null} props.report
 * @param {{ name?: string, trn?: string } | null} [props.branch]
 */
export function ZReportPrint({ report, branch }) {
  if (!report) return null

  const paymentLines = normalizePaymentMix(report.payment_mix)

  return (
    <div className="thermal-receipt-root pointer-events-none fixed -left-[9999px] top-0">
      <article className="thermal-receipt" aria-label="Z-report">
        <header className="thermal-receipt__header">
          <p className="thermal-receipt__title">{branch?.name ?? 'Salon branch'}</p>
          {branch?.trn ? <p>TRN: {branch.trn}</p> : null}
          <p>Z-REPORT</p>
        </header>

        <section className="thermal-receipt__meta">
          <Row label="Report" value={report.report_number ?? ''} />
          <Row label="Business date" value={report.business_date ?? ''} />
          <Row label="Generated" value={formatZReportDateTime(report.generated_at)} />
        </section>

        <section className="thermal-receipt__lines">
          <Row label="Gross sales" value={formatLedgerMoney(report.gross_sales)} />
          <Row label="Discounts" value={formatLedgerMoney(report.discount_total)} />
          <Row label="VAT" value={formatLedgerMoney(report.vat_total)} />
          <Row label="Net sales" value={formatLedgerMoney(report.net_sales)} />
          <Row label="Voids" value={`${report.void_count ?? 0} / ${formatLedgerMoney(report.void_amount)}`} />
        </section>

        <section className="thermal-receipt__totals">
          <p className="thermal-receipt__stylist">Payment mix</p>
          {paymentLines.map((line) => (
            <Row key={line.code} label={line.label} value={line.amount} />
          ))}
        </section>

        <section className="thermal-receipt__totals">
          <Row label="Opening float" value={formatLedgerMoney(report.opening_float)} />
          <Row label="Expected cash" value={formatLedgerMoney(report.closing_cash_expected)} />
          <Row label="Counted cash" value={formatLedgerMoney(report.closing_cash_counted)} />
          <div className="thermal-receipt__row thermal-receipt__total">
            <span>Variance</span>
            <span>{formatLedgerMoney(report.cash_variance)}</span>
          </div>
        </section>
      </article>
    </div>
  )
}

/**
 * @param {object} props
 * @param {string} props.label
 * @param {string} props.value
 */
function Row({ label, value }) {
  return (
    <div className="thermal-receipt__row">
      <span>{label}</span>
      <span>{value}</span>
    </div>
  )
}
